import {
  isEmptyText,
  parseTariff,
  Prismic,
  WrapText,
} from '@landsbankinn/prismic';
import { Column, Segment, TrailRow } from '@landsbankinn/ui';
import React from 'react';
import { InterestCard } from '../components/card/InterestCard';

interface IProps {
  fields: IField[];
}

interface IField {
  title: Prismic.RichText;
  copy: Prismic.RichText;
  sub_title: Prismic.RichText;
  number: Prismic.RichText;
  number_color: string;
  link: Prismic.Link;
  subtitle_position: 'Left' | 'Top';
  style?: any;
}

const Item = (
  {
    title,
    copy,
    sub_title,
    number,
    number_color,
    link,
    subtitle_position,
    style,
  }: IField,
  i: number,
) => {
  const titleText = !isEmptyText(title) ? Prismic.text(title) : null;
  const copyText = !isEmptyText(copy) ? Prismic.text(copy) : null;
  return (
    <Column md={4 / 12} key={`interest-callout-${i}`}>
      <InterestCard
        key={`${i}-${Prismic.text(title)}`}
        title={titleText ?? undefined}
        copy={copyText ?? undefined}
        subTitle={Prismic.text(sub_title) ?? undefined}
        number={
          number ? (
            <WrapText>{parseTariff(Prismic.text(number))}</WrapText>
          ) : undefined
        }
        color={number_color}
        link={link}
        subTitleAlign={subtitle_position}
        style={style}
      />
    </Column>
  );
};

export const InterestCalloutContainer = ({ fields }: IProps) => {
  if (fields?.length === 0) {
    return null;
  }
  return (
    <Segment paddingTop={110} paddingBottom={100}>
      <TrailRow>
        {fields?.map((item, index) => (
          <Item key={index} {...item} />
        ))}
      </TrailRow>
    </Segment>
  );
};
